// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
//CUSTOM JS BELOW 

// Fix aria-hidden focus issues on slick slider
function fixSlickAccessibility() {
  // Fix slides with aria-hidden="true" - make focusable elements not tabbable
  document.querySelectorAll('.slick-slide[aria-hidden="true"]').forEach(function(slide) {
    slide.querySelectorAll('a, button, input, [tabindex]').forEach(function(el) {
      el.setAttribute('tabindex', '-1');
    });
    // Also fix the slide itself if it's an anchor
    if (slide.tagName === 'A') {
      slide.setAttribute('tabindex', '-1');
    }
  });
  // Fix visible slides - make focusable elements tabbable
  document.querySelectorAll('.slick-slide[aria-hidden="false"]').forEach(function(slide) {
    slide.querySelectorAll('a, button, input').forEach(function(el) {
      el.setAttribute('tabindex', '0');
    });
    // Also fix the slide itself if it's an anchor
    if (slide.tagName === 'A') {
      slide.setAttribute('tabindex', '0');
    }
  });
}

// Initialize slider with accessibility event handlers
$('.responsive-one').on('init afterChange setPosition', function() {
  setTimeout(fixSlickAccessibility, 100);
});

$('.responsive-one').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4.5,
  slidesToScroll: 1,
  centerMode: false,
  prevArrow: `
    <button type="button" class="slick-prev" aria-label="Slide anterior">
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="27" viewBox="0 0 46 27" fill="none" aria-hidden="true">
        <path d="M32.8624 25.4064L43.9151 13.417L32.8624 1.24023M43.9151 13.2297H0.828125" stroke="white" stroke-opacity="0.7" stroke-width="2.06068"/>
      </svg>
    </button>
  `,
  nextArrow: `
    <button type="button" class="slick-next" aria-label="Slide siguiente">
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="27" viewBox="0 0 46 27" fill="none" aria-hidden="true">
        <path d="M32.8624 25.4064L43.9151 13.417L32.8624 1.24023M43.9151 13.2297H0.828125" stroke="white" stroke-opacity="0.7" stroke-width="2.06068"/>
      </svg>
    </button>
  `,
  accessibility: true,
  appendArrows: ".main_inn_sl", // 👈 put arrows inside .section div
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.7,
        slidesToScroll: 1
      }
    }
  ]
});

// Run on page load as fallback
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(fixSlickAccessibility, 500);
});
